module.exports = __webpack_public_path__ + "static/img/download_back2.24515e1a.png";